import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7fa72e2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-lg shadow pt-4 max-w-7xl mx-auto overflow-hidden" }
const _hoisted_2 = { class: "md:flex justify-between items-center px-4 md:px-6 pb-4" }
const _hoisted_3 = { class: "text-lg font-medium leading-6 text-gray-900" }
const _hoisted_4 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_5 = { class: "flex justify-start md:justify-end items-center mt-4 md:mt-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-4 md:px-6 bg-gray-100 border-t border-b py-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium text-gray-500" }, "Message")
], -1))
const _hoisted_7 = { class: "px-4 md:px-6 pt-5 pb-4" }
const _hoisted_8 = { class: "max-w-xl" }
const _hoisted_9 = { class: "md:flex justify-start items-center" }
const _hoisted_10 = { class: "md:w-1/2 md:pr-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "to-name",
  class: "block text-sm font-medium text-gray-700"
}, " To name: ", -1))
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = { class: "md:w-1/2 md:pl-1 mt-3 md:mt-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "to-email",
  class: "block text-sm font-medium text-gray-700"
}, " To email: ", -1))
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = { class: "flex justify-start items-center" }
const _hoisted_17 = { class: "w-3/4 md:w-1/2 relative" }
const _hoisted_18 = ["for"]
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = ["name", "onUpdate:modelValue"]
const _hoisted_21 = { class: "mt-3 max-w-xl" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "subject",
  class: "block text-sm font-medium text-gray-700"
}, " Subject: ", -1))
const _hoisted_23 = { class: "mt-1" }
const _hoisted_24 = { class: "mt-3 max-w-3xl" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "block text-sm font-medium text-gray-700"
}, " Message: ", -1))
const _hoisted_26 = { class: "mt-1" }
const _hoisted_27 = { class: "py-3 px-6 bg-gray-100 border-t flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewGridIcon = _resolveComponent("ViewGridIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PlusCircleIcon = _resolveComponent("PlusCircleIcon")!
  const _component_Wysiwig = _resolveComponent("Wysiwig")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_3, "Sharing " + _toDisplayString(_ctx.om.headline), 1),
        _createElementVNode("p", _hoisted_4, "to " + _toDisplayString(_ctx.distribution.originator.name) + " from " + _toDisplayString(_ctx.distribution.lender.name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "px-3 py-2 bg-white border text-sm rounded-md hover:border-gray-400 flex items-center",
          to: { name: 'deal-om-tracker' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ViewGridIcon, { class: "w-4 h-4 mr-1 text-gray-500" }),
            _createTextVNode(" OM Tracker ")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_6,
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "to-name",
                      id: "to-email",
                      class: "shadow-sm block w-full h-10 border px-3 text-sm border-gray-300 rounded-md bg-gray-100",
                      placeholder: "John Doe",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.to[0]['name']) = $event)),
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.config.to[0]['name']]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      name: "to-email",
                      id: "to-email",
                      class: "shadow-sm bg-gray-100 outline:none block w-full h-10 border px-3 text-sm border-gray-300 rounded-md",
                      placeholder: "you@example.com",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.to[0]['address']) = $event)),
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.config.to[0]['address']]
                    ])
                  ])
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.bcc, (bcc, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "max-w-xl relative mt-3",
                key: index
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (index == 0)
                      ? (_openBlock(), _createElementBlock("label", {
                          key: 0,
                          for: `bcc-email-${index}`,
                          class: "block text-sm font-medium text-gray-700"
                        }, " Bcc email: ", 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        name: `bcc-email-${index}`,
                        id: "to-email",
                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full h-10 border px-3 text-sm border-gray-300 rounded-md",
                        placeholder: "bcc@example.com",
                        "onUpdate:modelValue": ($event: any) => ((bcc['address']) = $event)
                      }, null, 8, _hoisted_20), [
                        [_vModelText, bcc['address']]
                      ])
                    ]),
                    _createVNode(_component_PlusCircleIcon, {
                      class: "w-6 h-6 text-indigo-400 hover:text-indigo-500 absolute cursor-pointer bottom-2 left-full ml-2",
                      onClick: _ctx.addBcc
                    }, null, 8, ["onClick"])
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "subject",
                  id: "subject",
                  class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full h-10 border px-3 text-sm border-gray-300 rounded-md",
                  placeholder: "Great loan opportunity!",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.subject) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.config.subject]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_Wysiwig, {
                  modelValue: _ctx.config.body,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.body) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              type: "submit",
              class: _normalizeClass(["bg-sky text-white text-sm rounded-md mr-3 py-2 px-4", { 'opacity-50 pointer-events-none': _ctx.pendingEmail }])
            }, " Send email ", 2),
            _createVNode(_component_router_link, {
              to: `/offering-memorandum/${_ctx.om.id}`,
              class: "bg-indigo-100 hover:bg-indigo-200 text-indigo-900 text-sm rounded-md py-2 px-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Preview OM ")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}